module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_1.b1b42c28.png";